import { Injectable } from '@angular/core';

import { AppointmentSlot, LabLocation } from '../models';

export interface LocationFilters {
  openNow: boolean;
  isWalgreens: boolean;
  openWeekends: boolean;
}

export interface SlotFilters {
  appointmentTimes: 'all' | 'am' | 'pm';
}

@Injectable()
export class LocationFilterService {
  filterLocations(
    locations: LabLocation[],
    filters: LocationFilters
  ): LabLocation[] {
    // If no checkbox filters are active, show all locations
    if (!filters.openNow && !filters.openWeekends && !filters.isWalgreens) {
      return locations;
    }

    return locations.filter((location) => {
      // Open Now filter - only show locations that are open now
      if (filters.openNow && !location.isOpenNow) {
        return false;
      }

      // Walgreens filter - only show Walgreens locations
      if (filters.isWalgreens && !location.isWalgreens) {
        return false;
      }

      // Open Weekends filter - only show locations open on weekends
      if (filters.openWeekends && !location.isOpenWeekends) {
        return false;
      }

      return true;
    });
  }

  filterSlots(
    slots: AppointmentSlot[],
    filters: SlotFilters
  ): AppointmentSlot[] {
    if (filters.appointmentTimes === 'all') {
      return slots;
    }

    return slots.filter((slot) => {
      const date = new Date(slot.dateTime);
      const hours = date.getHours();

      if (filters.appointmentTimes === 'am') {
        return hours < 12;
      } else if (filters.appointmentTimes === 'pm') {
        return hours >= 12;
      }

      return true;
    });
  }
}
